"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactDatetime = _interopRequireDefault(require("react-datetime"));
var _excluded = ["dropup", "alignRight", "onChange", "className", "mandatory", "dateValidation"]; // This workaround fixes the react minified #130 error for using external commonjs libs
// see https://github.com/vitejs/vite/issues/2139
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Datetime = _reactDatetime["default"]["default"] ? _reactDatetime["default"]["default"] : _reactDatetime["default"];
var isValidDate = function isValidDate(date) {
  return (0, _typeof2["default"])(date) === 'object';
};
var DatePicker = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var dropup = props.dropup,
    alignRight = props.alignRight,
    onChange = props.onChange,
    className = props.className,
    mandatory = props.mandatory,
    dateValidation = props.dateValidation,
    remainingProp = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    hasError = _useState2[0],
    setHasError = _useState2[1];
  var validateDate = function validateDate(dateToValidate) {
    return dateValidation ? dateValidation(dateToValidate) : isValidDate(dateToValidate);
  };
  var handleChange = function handleChange(date) {
    var isValid = mandatory ? validateDate(date) : true;
    setHasError(!isValid);
    onChange(date, isValid);
  };
  var classes = (0, _classnames["default"])('DatePicker', 'form-group', hasError && 'has-error', dropup && 'dropup', alignRight && 'align-right', className && className);

  // TODO: add support for setting ref to the input. Maybe add a "inputRef" prop to react-datetime
  return /*#__PURE__*/_react["default"].createElement(Datetime, (0, _extends2["default"])({
    ref: ref
  }, remainingProp, {
    onChange: handleChange,
    className: classes
  }));
});
DatePicker.defaultProps = {
  closeOnSelect: true,
  dropup: false,
  locale: 'en-GB',
  onChange: function onChange() {},
  clearableInput: false,
  minWidth: 0,
  mandatory: true
};
DatePicker.propTypes = {
  className: _propTypes["default"].string,
  closeOnSelect: _propTypes["default"].bool,
  clearableInput: _propTypes["default"].bool,
  initialValue: _propTypes["default"].object,
  locale: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  dropup: _propTypes["default"].bool,
  minWidth: _propTypes["default"].number,
  alignRight: _propTypes["default"].bool,
  mandatory: _propTypes["default"].bool,
  dateValidation: _propTypes["default"].func
};
var _default = DatePicker;
exports["default"] = _default;